import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import { AssetType, ContentTypeImage } from '../../../types/Content';

type Data = {
  isLoading: boolean;
  errorFetchingImages: boolean;
  imagesReferenceFrame: string;
  images: ContentTypeImage[];
};

export type AssetTypeData = {
  [AssetType.IMAGE]: Data;
  [AssetType.CHART_OR_GRAPH]: Data;
};

type OptionIdsHashMap = Record<string, AssetTypeData>;

export type ContentImagesHashMap = Record<string, OptionIdsHashMap>;

export const contentImagesStateSegment =
  stateSegmentWithReset<ContentImagesHashMap>({});
contentImagesStateSegment.debugLabel = 'contentImagesStateSegment';
